module.exports = __webpack_public_path__ + "static/media/cardJsusp.6cef1eba.svg";